import applicationService from '@/services/applicationService';
import DEFAULT_LANDLORD_ID from '@/utils/defaultLandlordId';
import ovStore from '@/store/overlatelser';
import auth from '@/services/auth';
import APPLICATION_TYPE from '@/utils/applicationType';

let isInitialized = false;
let isInitializing = null;

async function acceptInvite(inviteCode) {
  try {
    ovStore.commit('ovApplication/setIsAcceptingInvite', true);
    const invite = await applicationService.acceptOverlatelseInvite(inviteCode);
    ovStore.commit('ovApplication/setInviteSuccessData', invite);
    ovStore.commit('ovApplication/setApplicationId', invite.applicationId);
  } catch (err) {
    const status = err?.status;
    let inviteError = 'unknown';
    if (status === 404) {
      inviteError = '404';
    } else if (status === 409) {
      inviteError = '409';
    } else if (status === 410) {
      inviteError = '';
    }
    const role = err.response.data.role;
    ovStore.commit('ovApplication/removeInviteCode');
    ovStore.commit('ovApplication/setInviteError', inviteError);
    ovStore.commit('ovApplication/setInviteErrorUserRole', role);
  } finally {
    ovStore.commit('ovApplication/setIsAcceptingInvite', false);
  }
}

export function clearUserLocalStorage() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('idToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userId');
}

export default {
  get isInitialized() {
    return isInitialized;
  },

  async init() {
    if (isInitializing) return await isInitializing;

    isInitializing = (async () => {
      const applicationId = ovStore.state.ovApplication.applicationId;
      if (!applicationId) {
        const localStorageApplicationId = localStorage.getItem('applicationId');
        if (localStorageApplicationId) {
          ovStore.commit(
            'ovApplication/setApplicationId',
            localStorageApplicationId
          );
        }
      }

      const valid = await auth.validateSession();
      ovStore.commit('app/setAuthenticated', valid);

      if (!valid) {
        return;
      }

      const inviteCode = ovStore.state.ovApplication.inviteCode;
      const landlord = ovStore.state.app.landlord;
      const isPrivateFlow = ovStore.getters['ovApplication/isPrivateFlow'];

      if (inviteCode) {
        await acceptInvite(inviteCode);
      }

      const landlordIdWithFallback =
        landlord?.landlordId || DEFAULT_LANDLORD_ID;

      await ovStore.dispatch('ovApplication/fetchOverlatelseApplications', {
        landlordId: landlordIdWithFallback,
        ovType: isPrivateFlow
          ? APPLICATION_TYPE.OVERLATELSE_PRIVATE
          : APPLICATION_TYPE.OVERLATELSE_COMPANY
      });
      ovStore.commit('app/setAppReady', true);
    })();

    await isInitializing;
    isInitialized = true;
    isInitializing = null;
  }
};
